import React from 'react';
import {
	SypacButton,
	SypacIcon,
	SypacText,
} from '@sypac/component-library-react';
import { T } from '@tolgee/react';
import { TabButtonProps } from './OrderDetailsTabButton.interface';
import { cn } from '../../lib/utils';

const TabButton: React.FC<TabButtonProps> = ({
	tab,
	isActive,
	config,
	notificationCount,
	onClick,
	target,
	inContracts = false,
}) => {
	const count = typeof notificationCount === 'number' ? notificationCount : 0;

	const shouldShowNotification = inContracts
		? count > 0
		: target === 'producer'
		? count >= 1
		: count > 1;

	const displayCount = inContracts
		? count
		: target === 'producer'
		? count
		: count
		? count - 1
		: 0;

	return (
		<SypacButton variant="secondary" size="small" className="w-full">
			<button
				type="button"
				className={cn(
					'w-full h-[40px] rounded-lg flex gap-2 items-center border-none transition group',
					isActive
						? 'bg-primary-violet text-white'
						: 'hover:bg-gray-10 bg-alabaster text-gray-80',
				)}
				onClick={() => onClick(tab)}
			>
				<SypacIcon
					iconName={config.icon}
					size="custom"
					width="24px"
					height="24px"
					className="mb-[2px]"
				/>
				<div className="flex items-center gap-3">
					<SypacText variant="body-regular-medium">
						<p>
							<T keyName={config.label}>{config.translatedLabel}</T>
						</p>
					</SypacText>

					{shouldShowNotification && (
						<div
							className={cn(
								'w-[23px] h-[22px] flex items-center justify-center bg-gray-10 rounded-[8px] mb-[2px] transition',
								isActive
									? 'bg-white text-gray-90'
									: 'bg-gray-10 group-hover:bg-gray-20',
							)}
						>
							<SypacText variant="body-regular-medium">
								<p className="mt-[2px]">{displayCount}</p>
							</SypacText>
						</div>
					)}
				</div>
			</button>
		</SypacButton>
	);
};

export default TabButton;
